/* ============================================================================
   LINKS LEFT BEHIND BY THE PAGE SPLIT

   pm-home.liquid was built as one long page: hero, lineup, 3D builder, order
   tracking, contact. Every internal link in it is an anchor to a section
   further down - '#pm-3d', '#pm-track', '#pm-bikes'.

   The builder and the tracker have since moved to their own pages and their
   sections are hidden on the homepage. The anchors still exist, still point at
   those ids, and now scroll to something invisible. To a visitor the button
   simply does nothing, which is worse than a broken link: there is no error to
   report, so they assume the site is broken and leave.

   This repoints them. Also here: one wording fix that no stylesheet can reach.
   All of it is a consequence of not editing the 1400-line section, and it is
   about as far as that approach should be pushed - a fourth correction means
   the section itself should be opened properly.
   ============================================================================ */
(function () {

  /* Where the dead anchors should go instead. */
  var CHOOSER = '/pages/3d-builder';      /* pick a bike, then configure it */
  var TRACKER = '/pages/track-your-mini';

  /* A bike that has a builder page of its own. Add to this when the Ultra Bee
     gets one. */
  var BUILDERS = {
    'custom-mini-surron': '/pages/build-surron'
  };

  /* ==========================================================================
     1. BIKE CARDS

     The card link is built as:

         href="{% if product.handle == customizer_product %}#pm-3d{% else %}{{ product.url }}{% endif %}"

     Both branches are wrong for a configurable bike. The anchor is dead, as
     above; the product URL goes to the theme's stock product page with variant
     dropdowns, which is the wrong room for a bike whose whole pitch is
     configuring it in 3D. Covering both means this holds whether or not
     `customizer_product` is set in the theme editor later.
     ========================================================================== */
  function retargetCards() {
    var links = document.querySelectorAll('.pm-card-link');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';

      /* A card pointing at the builder goes straight to the one builder page,
         skipping the chooser - the card already chose. */
      if (href === '#pm-3d') {
        a.setAttribute('href', BUILDERS['custom-mini-surron']);
        continue;
      }

      var match = href.match(/\/products\/([^?#\/]+)/);
      if (!match) continue;

      var target = BUILDERS[match[1]];
      if (target) a.setAttribute('href', target);
    }
  }

  /* ==========================================================================
     2. EVERY OTHER DEAD ANCHOR

     The hero buttons are the ones that matter - "Open the 3D Builder" is the
     single most prominent call to action on the site and it did nothing at all.
     These go to the chooser rather than straight to a builder, matching what
     the header nav does, so the route is the same wherever you start.
     ========================================================================== */
  function retargetAnchors() {
    var dead = document.querySelectorAll('a[href="#pm-3d"], a[href="#pm-track"]');
    for (var i = 0; i < dead.length; i++) {
      var a = dead[i];
      if (a.classList.contains('pm-card-link')) continue;   /* handled above */
      a.setAttribute('href', a.getAttribute('href') === '#pm-track' ? TRACKER : CHOOSER);
    }
  }

  /* ==========================================================================
     3. "A DAY" -> "24 HOURS"

     The chip under the contact heading is a CSS pseudo-element and was changed
     in page-contact.css. This is the confirmation shown after the form is
     sent - real text in the section's markup, which no stylesheet can reach.

     "A day" is vague in a way that works against you: someone writing at 9pm
     reads it as tomorrow morning, someone writing Friday reads it as Monday.
     The text node is rewritten rather than hidden behind CSS, so screen readers
     announce the confirmation once, and correctly.
     ========================================================================== */
  function fixReplyTime() {
    var nodes = document.querySelectorAll('.pm-ok, .pm-addnote, .pm-lede');
    for (var i = 0; i < nodes.length; i++) {
      var text = nodes[i].textContent;
      if (text && /within a day/i.test(text)) {
        nodes[i].textContent = text.replace(/within a day/gi, 'within 24 hours');
      }
    }
  }

  function run() {
    retargetCards();
    retargetAnchors();
    fixReplyTime();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.__pmCardLinks = { run: run, builders: BUILDERS };
})();
